import { ResearchAreaActionType } from '../actionTypes/researchArea';
import { PostDispatch, ResearchArea } from '../types';

const researchAreaReducer = (
    state: ResearchArea[] = [],
    action: PostDispatch
): ResearchArea[] => {
    switch (action.type) {
        case ResearchAreaActionType.GET_RESEARCH_AREAS_BY_USER_INTAKES:
        case ResearchAreaActionType.GET_ALL_RESEARCH_AREAS:
            return [...(action.payload as ResearchArea[])];

        case ResearchAreaActionType.DELETE_RESEARCH_AREA: {
            const deletedResearchArea = action.payload as ResearchArea;
            const updatedState = state.filter(
                (researchArea) =>
                    researchArea._id !== deletedResearchArea?._id ?? []
            );
            return [...updatedState];
        }

        case ResearchAreaActionType.UPDATE_RESEARCH_AREA: {
            const updatedResearchArea = action.payload as ResearchArea;
            const updatedResearchAreaIndex = state.findIndex(
                (ra) => ra._id === updatedResearchArea._id
            );
            const updatedState = [...state];
            updatedState[updatedResearchAreaIndex] = updatedResearchArea;

            return updatedState;
        }

        default:
            return state;
    }
};

export default researchAreaReducer;
